<template>
  <div id="connect">

    <div class="p-30 container text-center" v-if="!has_custom_load_states && load_states.loading">
      <h1 class="m-0 lh-34 fs-26">Loading...</h1>
    </div>

    <div class="p-30 container text-center" v-if="!has_custom_load_states && load_states.connected">
      <h1 class="m-0 lh-34 fs-26">Successfully Connected. You may now close your browser.</h1>
    </div>

    <div v-if="load_states.has_portal">
      <Portal :connection_data="connection_data" :portal="api.portal"
              v-on:emitRegistrationMethodData="createRegistration"/>
    </div>

    <div v-if="has_custom_load_states || load_states.has_custom_portal">
      <DynamicTemplate
          :connection_data="connection_data"
          :portal="api.portal"
          :parent_load_states="load_states"
          :parent_error="error"
          :template="custom_template_name"
          v-on:emitRegistrationMethodData="createRegistration"
          v-on:force_standard="forceStandard"
          v-on:emitCustomError="emitCustomError"
      />
    </div>

    <div class="p-30 container text-center" v-if="!has_custom_load_states && load_states.error">
      <div class="m-0 mb-15"><img class="mw-100" src="../assets/logo-allbridge.png"/></div>
      <p class="m-0 mb-15"><strong>24/7 Internet Support by Allbridge: </strong>
        {{ support_phone ? support_phone : '8663686310' | phone }}</p>
      <div class="mb-30">
        <h1 class="m-0 mb-15 lh-34 fs-26"><strong>{{ error ? error.message : 'Error' }}</strong></h1>
        <div v-if="error.invalid_fields">
          <p :key="index" class="m-0 mb-5" v-for="(invalid_field,index) in error.invalid_fields">
            <strong>{{ index }}</strong>: {{ invalid_field }}</p>
        </div>
      </div>
      <div class="mb-30" v-if="error.invalid_fields">
        <div class="row border mb-15" v-if="error.invalid_fields.nseid">
          <div class="col col-40 py-0 text-right lh-1-4"><strong class="p-10 d-ib mt-2 text-14">Network ID:</strong>
          </div>
          <div class="col col-60 py-0"><input class="input-text" placeholder="NSEID" v-model="connection_data.nseid"/>
          </div>
        </div>
        <div class="row border mb-15" v-if="error.invalid_fields.property_id">
          <div class="col col-40 py-0 text-right lh-1-4"><strong class="p-10 d-ib mt-2 text-14">Property ID:</strong>
          </div>
          <div class="col col-60 py-0"><input class="input-text" placeholder="Property ID"
                                              v-model="connection_data.property_id"/></div>
        </div>
        <div class="row border mb-15">
          <div class="col col-40 py-0 text-right lh-1-4"><strong class="p-10 d-ib mt-2 text-14">VLAN Port:</strong>
          </div>
          <div class="col col-60 py-0"><input class="input-text" placeholder="Port"
                                              v-model="connection_data.vlan_port"/></div>
        </div>
        <div class="row border mb-15">
          <div class="col col-40 py-0 text-right lh-1-4"><strong class="p-10 d-ib mt-2 text-14">IP Address:</strong>
          </div>
          <div class="col col-60 py-0"><input class="input-text" placeholder="IP Address"
                                              v-model="connection_data.client_ip"/></div>
        </div>
        <div class="row border mb-15">
          <div class="col col-40 py-0 text-right lh-1-4"><strong class="p-10 d-ib mt-2 text-14">MAC Address:</strong>
          </div>
          <div class="col col-60 py-0"><input class="input-text" placeholder="MAC Address"
                                              v-model="connection_data.client_mac"/></div>
        </div>
      </div>
      <p class="m-0 mb-30" v-if="try_again">
        <button @click="clickTryAgain" class="btn-default">{{ try_again ? 'Try Again' : 'Connect' }}</button>
      </p>
      <p class="m-0" v-if="connection_data.client_agent"><strong>User Agent:</strong> {{ connection_data.client_agent }}
      </p>
    </div>

  </div>
</template>
<script>
import axios from 'axios';
import {HTTP} from '@/utilities/http'
import Portal from '@/components/Portal'
import DynamicTemplate from '@/components/DynamicTemplate'

export default {
  name: 'connect',
  components: {
    Portal,
    DynamicTemplate
  },
  data() {
    return {
      has_custom_load_states: false,
      api: {
        portal: {},
        registration_post: {},
      },
      load_states: {
        loading: true,
        has_custom_portal: false,
        has_portal: false,
        connected: false,
        error: false,
      },
      support_phone: null,
      custom_template_name: null,
      force_standard: false,
      try_again: false,
      connection_data: {
        nseid: null,
        property_id: null,
        gateway_slug: null,
        location_index: null,
        ppli: null,
        vlan_port: null,
        client_ip: null,
        client_mac: null,
        client_agent: null,
        tmp: null
      },
      pending_attempts: 0,
      pending_registration_data: {
        registration_id: null,
        property_id: null,
      },
      error: {
        status: null,
        message: null,
        invalid_fields: null,
      },
    }
  },
  filters: {
    phone: function (value) {
      if (!value) return '';
      value = value.toString();
      return '(' + value.substr(0, 3) + ') ' + value.substr(3, 3) + '-' + value.substr(6, 4);
    }
  },
  async created() {
    ////// JANKFEST CAREFUL ////////
    // We are intercepting HTTP here and reassinging the url for sites being converted
    // this allows us to use the endpoint to determing the status of the site migration

    const devHostname = window.location.hostname.includes('dev');
    const checkMigratedUrl = devHostname
      ? "https://dev-api.skyway-admin.com/api/check-migrated/"
      : "https://skyadmin.io/api/check-migrated/";
    const checkMigratedAgsUrl = devHostname
      ? "https://dev-api.skyway-admin.com/api/check-migrated-ags/"
      : "https://skyadmin.io/api/check-migrated-ags/";
    const appBaseUrl = devHostname
      ? 'https://dev.skyway-app.com/api/'
      : 'https://skyway-app.com/api/';

    if (typeof this.$route.query.UI !== "undefined") {
      // nomadix
      await axios.get(checkMigratedUrl + this.$route.query.UI)
      .then(function (response) {
          // console.log(response.data);
          if(response.data.migrated) {
            HTTP.defaults.baseURL = appBaseUrl;
          }
      })
      .catch(function (error) {
          console.error(error);
      })
    } else if (typeof this.$route.query.property_id !== "undefined") {
      // ags
      await axios.get(checkMigratedAgsUrl + this.$route.query.property_id)
      .then(function (response) {
          // console.log(response.data);
          if(response.data.migrated) {
            HTTP.defaults.baseURL = appBaseUrl
          }
      })
      .catch(function (error) {
          console.error(error);
      })
    } else if (typeof this.$route.query.location_index !== "undefined") {
      // ANTlabs always uses location_index and always goes to skyway-app.com
      HTTP.defaults.baseURL = 'https://skyway-app.com/api/'
    }
    /////// END JANKFEST //////////

    // Marriott registration
    // The Sky API handles the auth response from m.com which then
    // redirects to splash.skyadmin.io/?registration_id=123&property_id=123
    if (this.$route.query.registration_id && this.$route.query.property_id) {
      this.pending_registration_data.registration_id = this.$route.query.registration_id;
      this.pending_registration_data.property_id = this.$route.query.property_id;
      this.checkPendingRegistration();
      return;
    }

    // Determine our gateway type
    // and load appropriate connection data.
    if (typeof this.$route.query.UI !== "undefined") {
      this.setConnectionDataFromNomadix();
    } else if (typeof this.$route.query.property_id !== "undefined") {
      this.setConnectionDataFromAGS();
    } else if (typeof this.$route.query.location_index !== "undefined") {
      this.setConnectionDataFromAntlabs();
    } else {
      this.changeLoadState('error');
    }
  },
  methods: {
    // if we have a mistmatch in custom template name from the portal
    // to the directory structure here the system doesn't know which template to choose
    // so we force a standard template for that zone. this is emmited from'DyanamicTemplate.vue'
    forceStandard: function (force) {
      this.force_standard = force
      this.getPortal()
    },
    emitCustomError: function (error) {
      this.error.status = 'Error';
      this.error.message = error;
      this.changeLoadState('error');
    },
    setConnectionDataFromAGS: function () {
      try {
        // Standard splash page from AGS
        // example AGS URL:
        // /?property_id=123&vlan_port=1000&ip_address=10.20.30.40&mac_address=dabeefcafefe

        // If we have none of the required fields,
        // do not try again,
        // and throw an exception
        if (
            !this.$route.query.property_id &&
            !this.$route.query.vlan_port &&
            !this.$route.query.ip_address &&
            !this.$route.query.mac_address
        ) {
          this.try_again = false;
          throw "";
        }

        // Ensure each field is filled,
        // or throw a specific exception.
        if (!this.$route.query.property_id) throw "Invalid connection data. Property ID required.";
        if (!this.$route.query.vlan_port) throw "Invalid connection data. Network Port (VLAN) required.";
        if (!this.$route.query.ip_address) throw "Invalid connection data. Device IP Address required.";
        if (!this.$route.query.mac_address) throw "Invalid connection data. Device Mac Address required.";

        // Set the connection data,
        // enable 'try_again',
        // and get the portal
        this.connection_data.property_id = this.$route.query.property_id;
        this.connection_data.vlan_port = this.$route.query.vlan_port;
        this.connection_data.client_ip = this.$route.query.ip_address;
        this.connection_data.client_mac = this.$route.query.mac_address;
        this.connection_data.client_agent = window.navigator.userAgent;
        this.try_again = true;
        this.$router.push('/');
        this.getPortal();

      } catch (e) {

        // Handle exceptions thrown above.
        this.error.status = 'Error';
        this.error.message = e.message ? e.message : e;
        this.changeLoadState('error');

      }
    },
    setConnectionDataFromNomadix: function () {
      try {
        // Standard splash page from nomadix
        // example nomadix return URL:
        // /?UI=00b400&NI=0050E802A4EA&UIP=64.183.1.195&MA=998877665544&PORT=33&SIP=192.168.0.190
        if (!this.$route.query.UI && !this.$route.query.PORT && !this.$route.query.SIP && !this.$route.query.MA) {
          this.try_again = false;
          throw "";
        }
        if (!this.$route.query.UI) throw "Invalid connection data. Network ID required.";
        if (!this.$route.query.PORT) throw "Invalid connection data. Network Port (VLAN) required.";
        if (!this.$route.query.SIP) throw "Invalid connection data. Device IP Address required.";
        if (!this.$route.query.MA) throw "Invalid connection data. Device Mac Address required.";

        this.connection_data.nseid = this.$route.query.UI;
        this.connection_data.vlan_port = this.$route.query.PORT;
        this.connection_data.client_ip = this.$route.query.SIP;
        this.connection_data.client_mac = this.$route.query.MA;
        this.connection_data.client_agent = window.navigator.userAgent;
        this.try_again = true;
        this.$router.push('/');
        this.getPortal();
      } catch (e) {
        this.error.status = 'Error';
        this.error.message = e.message ? e.message : e;
        this.changeLoadState('error');

      }
    },
    setConnectionDataFromAntlabs: function () {
      try {
        // Standard splash page from ANTlabs
        // example URL:
        // /?gateway=sheraton-grand-cristfort-downtown-1&vlan=LAN%20No%20VLAN&client_ip=192.168.3.249&client_mac=5C%3A26%3A0A%3A86%3A98%3A2B&ppli=eth0&location_index=2

        // Ensure all fields are set.
        if (!this.$route.query.gateway) throw "Invalid connection data. Gateway required.";
        if (!this.$route.query.vlan) throw "Invalid connection data. Network Port (VLAN) required.";
        if (!this.$route.query.client_ip) throw "Invalid connection data. Client IP Address required.";
        if (!this.$route.query.client_mac) throw "Invalid connection data. Client Mac Address required.";
        if (!this.$route.query.location_index) throw "Invalid connection data. Location Index required.";
        if (!this.$route.query.ppli) throw "Invalid connection data. PPLI required.";

        // Translate fields into the expected format
        this.connection_data.gateway_slug = this.$route.query.gateway;
        this.connection_data.vlan_port = decodeURIComponent(this.$route.query.vlan);
        this.connection_data.client_ip = this.$route.query.client_ip;
        this.connection_data.client_mac = decodeURIComponent(this.$route.query.client_mac);
        this.connection_data.location_index = this.$route.query.location_index;
        this.connection_data.ppli = this.$route.query.ppli;
        this.connection_data.client_agent = window.navigator.userAgent;
        this.try_again = true;
        this.$router.push('/');
        this.getPortal();

      } catch (e) {
        this.error.status = 'Error';
        this.error.message = e.message ? e.message : e;
        this.changeLoadState('error');
      }

    },
    getPortal: function () {

      // Get normal fields
      let fields = {
        vlan: this.connection_data.vlan_port,
        mac_address: this.connection_data.client_mac,
        ip_address: this.connection_data.client_ip,
      };

      // Use nseid OR property_id OR location_index
      if (this.connection_data.nseid) {
        fields.nseid = this.connection_data.nseid;
      } else if (this.connection_data.property_id) {
        fields.property_id = this.connection_data.property_id;
      } else if (this.connection_data.location_index) {
        fields.gateway_slug = this.connection_data.gateway_slug;
        fields.location_index = this.connection_data.location_index;
        fields.ppli = this.connection_data.ppli;
      }

      HTTP.post('portals', fields).then(function (response) {
        try {
          // Already connected
          if (response.data.data.registration_status == "Successful") {
            this.changeLoadState('connected');
            return;
          }
          // Marriott auth
          // If splash page is hosted at m.com for auth, redirect the user there.
          if (response.data.data.url) {
            window.location.replace(response.data.data.url);
            return;
          }
          // Standard auth
          if (response.data.data.template.length == 0) throw "No template assigned to VLAN.";
          if (response.data.data.registration_methods.length == 0 && response.data.data.access_codes.length == 0) throw "No registration methods assigned to VLAN.";

          this.support_phone = response.data.data.template.support_phone;
          this.api.portal = response.data.data;

          // check for custom flag on the template
          // if it exists we're going to pass the custom_template_name for lookup
          if (response.data.data.template.custom && !this.force_standard) {
            this.custom_template_name = response.data.data.template.custom_template_name;
            if (this.checkIfRegMethodIdExists(10)) {
              this.has_custom_load_states = true;
            }
            this.changeLoadState('has_custom_portal');
          } else {
            this.changeLoadState('has_portal');
          }

        } catch (e) {
          this.error.status = 'Error';
          this.error.message = e.message ? e.message : e;
          this.changeLoadState('error');
        }
      }.bind(this)).catch(function (error) {
        this.error.status = error.response.data.status;
        if (typeof error.response.data.invalid_fields !== 'undefined') {
          this.error.message = 'Invalid Fields';
          this.error.invalid_fields = error.response.data.invalid_fields;
        } else {
          this.error.message = error.response.data.message;
        }
        this.changeLoadState('error');
      }.bind(this));
    },
    createRegistration: function (emitted) {
      document.documentElement.removeAttribute('class');
      // Create a Registration from the selected and stored data
      // These are emitted from PortalRegistrationMethod -> Portal -> Here
      this.changeLoadState('loading');

      let fields = {
        nseid: this.connection_data.nseid,
        property_id: this.api.portal.property_id,
        gateway_slug: this.connection_data.gateway_slug,
        location_index: this.connection_data.location_index,
        ppli: this.connection_data.ppli,
        vlan_id: this.api.portal.vlan_id,
        mac_address: this.connection_data.client_mac,
        ip_address: this.connection_data.client_ip,
        registration_method_id: emitted.registration_method_id,
        ...( emitted.rateplan_id && { rateplan_id: emitted.rateplan_id }),
        ...( emitted.access_code && { access_code: emitted.access_code }),
        ...( emitted.email_address && { email_address: emitted.email_address }),
        ...( emitted.last_name && { last_name: emitted.last_name }),
        ...( emitted.first_name && { first_name: emitted.first_name }),
        ...( emitted.room_number && { room_number: emitted.room_number }),
        ...( emitted.audit_number && { audit_number: emitted.audit_number }),
        ...( emitted.zip_code && { zip_code: emitted.zip_code }),
        ...( emitted.pin && { pin: emitted.pin }),
        ...( emitted.email_opt_in && { email_opt_in: emitted.email_opt_in }),
        ...( emitted.club_code && { club_code: emitted.club_code } ),
        ...( emitted.member_number && { member_number: emitted.member_number } ),
        ...( emitted.langham && { langham: emitted.langham })
      }

      HTTP.post('portalregistrations', fields).then(function (response, emitted) {
        try {
          if (!response.hasOwnProperty('data')) throw "Empty response data from API server.";
          if (!response.data.hasOwnProperty('data')) throw "Empty response data from API server.";
          if (response.data.data.hasOwnProperty('error_message')) {
            if (response.data.data.error_message) throw response.data.data.error_message;
          }

          if (response.data.data.registration_status == "Failed") throw response.data.data.error;

          // PMS login
          // requires checking registration status before success
          if (response.data.data.registration_status == "Pending" && response.data.data.registration_id && response.data.data.property_id) {
            this.pending_registration_data.registration_id = response.data.data.registration_id;
            this.pending_registration_data.property_id = response.data.data.property_id;
            this.checkPendingRegistration();
            return;
          }

          // Value does not exist in the array of objects
          this.changeLoadState('connected');

          if (!this.has_custom_load_states && response.data.data.url) {
            window.location = response.data.data.url;
          }

        } catch (e) {
          this.error.status = 'Error';
          this.error.message = e.message ? e.message : e;
          this.changeLoadState('error');

        }
      }.bind(this)).catch(function (error) {
        this.error.status = error.response.data.status;
        if (typeof error.response.data.invalid_fields !== 'undefined') {
          this.error.message = 'Invalid Fields';
          this.error.invalid_fields = error.response.data.invalid_fields;
        } else {
          this.error.message = error.response.data.message;
        }
        this.changeLoadState('error');
      }.bind(this));
    },
    checkIfRegMethodIdExists: function(id) {
        const arr = this.api.portal.registration_methods;
        const valueToCheck = id;

        const exists = arr.some(obj => obj.registration_method_id === valueToCheck);

        return exists;
    },
    checkPendingRegistration: function () {
      this.changeLoadState('loading');
      this.pending_attempts++;
      var fields = {
        registration_id: this.pending_registration_data.registration_id,
        property_id: this.pending_registration_data.property_id
      };
      HTTP.post('portalpendingchecks', fields).then(function (response) {
        try {
          if (this.pending_attempts === 20) throw "Too many attempts receiving status 204 from API server.";
          if (!response.data.data.hasOwnProperty('status_code')) throw "Empty response from API server.";
          if (response.data.data.status_code == 200) {

            if (response.data.data.registration_status == "Successful") {
              this.changeLoadState('connected');
            }
            // Could be final URL or redirect back to Marriott if invalid credentials
            if (response.data.data.url !== '') {
              window.location = response.data.data.url
              return;
            }
            // Check if status failed
            if (response.data.data.registration_status == "Failed") throw response.data.data.error;

            return;
          }
          // If status code is 204, the registration is still pending
          // wait 3s to check again
          if (response.data.data.status_code == 204) {
            setTimeout(function () {
              this.checkPendingRegistration();
            }.bind(this), 3000);

          }
        } catch (e) {
          this.error.status = 'Error';
          this.error.message = e.message ? e.message : e;
          this.changeLoadState('error');
        }
      }.bind(this)).catch(function (error) {
        this.error.status = error.response.data.status;
        this.error.message = error.response.data.message;
        this.changeLoadState('error');
      }.bind(this));
    },
    clickTryAgain: function () {
      if (this.connection_data.nseid) {
        window.location = '/?UI=' + this.connection_data.nseid +
            '&PORT=' + this.connection_data.vlan_port +
            '&SIP=' + this.connection_data.client_ip +
            '&MA=' + this.connection_data.client_mac;
      } else if (this.connection_data.property_id) {
        window.location = '/?property_id=' + this.connection_data.property_id +
            '&vlan_port=' + this.connection_data.vlan_port +
            '&ip_address=' + this.connection_data.client_ip +
            '&mac_address=' + this.connection_data.client_mac;
      } else if (this.connection_data.location_index) {
        window.location = '/?location_index=' + this.connection_data.location_index +
            '&gateway=' + this.connection_data.gateway_slug +
            '&vlan=' + this.connection_data.vlan_port +
            '&client_ip=' + this.connection_data.client_ip +
            '&client_mac=' + this.connection_data.client_mac +
            '&ppli=' + this.connection_data.ppli;
      }
    },
    clickAdvancedConnect: function () {
      this.$router.push({name: 'Reconnect', params: {connection_data: this.connection_data}});
    },
    changeLoadState: function (state) {
      for (let load_state in this.load_states) {
        this.load_states[load_state] = (state == load_state);
      }
    },

  }
}
</script>
<style>
.input-text {
  display: block;
  border-radius: 6px;
  border: 1px solid #cccccc;
  color: #000000;
  overflow: visible;
  width: 100%;
  padding: 15px;
  font-size: 16px;
}
</style>
